import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Compact two-column shortcut tile: small icon with a label underneath.
 * Used by the Company and Banking panels.
 */
export default function DashboardShortcut({ icon: Icon, label, path }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="desk-shortcut" title={label} onClick={() => path && navigate(path)}>
      <span className="desk-shortcut-icon"><Icon /></span>
      <span className="desk-shortcut-label">{label}</span>
    </button>
  );
}
